module.exports = __webpack_public_path__ + "img/yz-gift.09234a78.svg";